// src/components/layout/Footer.js

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        {/* Пока пусто — можно добавить текст, ссылки, копирайт и т.д. */}
      </div>
    </footer>
  );
};

export default Footer;


